export default __webpack_public_path__ + "f3578f16028f613487285a1c28054665.jpeg";